import { LeftSideDefaultClassName } from 'app/src/features/Shopping/shared/utils'
import type { refundApi } from 'app/src/services/welfareportal'
import { Tag } from 'app/src/shared/components'
import { useTranslation } from 'app/src/shared/hooks'

export function RefundLeftPanelSide(props: { refund: refundApi.Refund; statusMode?: boolean; className?: string }) {
  const { t } = useTranslation('shopping', { keyPrefix: 'Refund' })

  return (
    <div className={props.className ?? LeftSideDefaultClassName}>
      <div className='flex flex-row'>
        <div className='pl-4'>
          <div>
            {typeof props.statusMode !== 'undefined' && props.statusMode ? (
              <Tag
                pt={{
                  root: {
                    className: `mt-0 mb-0 h-[28px] ${(props.refund.status.value === 'CANCELED' || props.refund.status.value === 'REJECTED') && 'bg-[#fae8eb] text-[#BF0B20]'}`,
                  },
                }}
                tag={t('StateMapping')[props.refund.status?.value]?.label}
              />
            ) : (
              t('productDescription')
            )}
          </div>
          <div className='mt-4 max-w-lg text-2xl font-bold' dangerouslySetInnerHTML={{ __html: props.refund.category ?? '' }} />
        </div>
      </div>
    </div>
  )
}
